import { getRequest } from '../services/requestHandler';
import { BsgBall } from '../models';

export const getBsgBalls = async () => {
  const url = 'bsgball/getBsgBalls?activeOnly=true';
  const response = await getRequest<BsgBall>('GetBsgBalls', url);
  return response;
};
